module.exports = "<app-locationnavtab></app-locationnavtab>\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/location-routes/location-routes.component.html
// module id = ./src/app/components/location-routes/location-routes.component.html
// module chunks = main